import PromoBoxDash from './PromoBoxDashboard';

export const PromoBoxDashboard = PromoBoxDash;
